const features = [
  {
    icon: 'ri-file-text-line',
    title: 'Spreadsheet Templates',
    description: 'Access a vast library of professionally designed templates for business, finance, inventory, and project management — ready to use instantly.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Business Management',
    description: 'Track KPIs, manage workflows, and organize business data with powerful spreadsheet tools built for growing companies.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Financial Tracking',
    description: 'Monitor budgets, forecast revenue, track expenses, and generate financial reports with automated calculations and clean formatting.',
  },
  {
    icon: 'ri-archive-line',
    title: 'Inventory Control',
    description: 'Manage stock levels, track product movements, and optimize inventory management with real-time spreadsheet tracking solutions.',
  },
  {
    icon: 'ri-database-2-line',
    title: 'Data Organization',
    description: 'Structure and analyze large datasets with advanced sorting, filtering, and visualization tools built into every spreadsheet.',
  },
  {
    icon: 'ri-rocket-line',
    title: 'Productivity Tools',
    description: 'Automate repetitive tasks, create custom formulas, and integrate with other business tools to maximize your workflow efficiency.',
  },
];

export default function FeaturesGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide mb-4">
            Core Features
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-4">
            Everything You Need In One Platform
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">
            Vigorbuy Spreadsheet combines essential business tools with an intuitive interface, giving you everything needed to manage data effectively.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-background-50 border border-background-200/60 rounded-2xl p-6 hover:border-primary-200/60 transition-all duration-300 cursor-default"
            >
              <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-accent-600 text-lg`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-950 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}